import { useEffect, useState } from "react";

/** Поле ввода с задержкой: в адрес уходит `trim()` черновика через `delay` мс после ввода.
 *  Черновик не перетирается адресом, если совпадает с ним после `trim()` — иначе пробел в конце
 *  («крем ») съедался бы, едва адрес обновится, и следующее слово склеивалось бы с прошлым. */
export function useDebouncedText(
  value: string,
  onChange: (v: string) => void,
  delay = 400,
): [string, (v: string) => void] {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft((d) => (d.trim() === value ? d : value)), [value]);
  useEffect(() => {
    if (draft.trim() === value) return;
    const t = setTimeout(() => onChange(draft.trim()), delay);
    return () => clearTimeout(t);
  }, [draft, value, onChange, delay]);
  return [draft, setDraft];
}
